var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "cart-page__body" }, [
    _c("div", { staticClass: "cart-page__content" }, [
      _c("div", { staticClass: "cart-page__products cart-products" }, [
        _c(
          "div",
          { staticClass: "cart-products__items" },
          _vm._l(_vm.$cart.items, function (item) {
            return _c(
              "div",
              {
                key: "cart_item" + item.id,
                staticClass: "cart-products__item",
              },
              [
                _c("div", { staticClass: "cart-product-item" }, [
                  _c("div", { staticClass: "cart-product-item__icon" }, [
                    _c("img", {
                      staticClass: "cart-product-item__img",
                      attrs: {
                        src: _vm.baseUrl + item.thumbnail,
                        alt: item.name,
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "cart-product-item__content" }, [
                    _c("div", { staticClass: "cart-product-item__main-info" }, [
                      _c("div", { staticClass: "cart-product-item__name" }, [
                        _c(
                          "a",
                          {
                            staticClass: "cart-product-item__link",
                            attrs: {
                              href: item.get_absolute_url,
                              target: "_blank",
                            },
                          },
                          [_vm._v(_vm._s(item.name))]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("ul", { staticClass: "cart-product-item__labels" }, [
                        item.sale_percent
                          ? _c(
                              "li",
                              {
                                staticClass:
                                  "cart-product-item__label product-label product-label--sale",
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "product-label__text product-label__text--sale",
                                  },
                                  [
                                    _vm._v(
                                      "-" +
                                        _vm._s(item.sale_percent.toFixed(0)) +
                                        "%"
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        item.is_popular
                          ? _c(
                              "li",
                              {
                                staticClass:
                                  "cart-product-item__label product-label",
                              },
                              [
                                _c("i", {
                                  staticClass: "fa fa-fire product-label__icon",
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "product-label__text" },
                                  [_vm._v("Хит!")]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "cart-product-item__price-area" },
                      [
                        _c("div", { staticClass: "cart-product-item__price" }, [
                          _vm._v(
                            _vm._s(
                              _vm.formatNumberWithSpaces(
                                item.total_price.toFixed(0)
                              )
                            ) + " руб."
                          ),
                        ]),
                        _vm._v(" "),
                        item.profit
                          ? _c(
                              "div",
                              { staticClass: "cart-product-item__price-raw" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatNumberWithSpaces(
                                      item.raw_total_price.toFixed(0)
                                    )
                                  ) + " руб."
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "cart-product-item__actions" }, [
                      _c("div", { staticClass: "cart-actions" }, [
                        _c(
                          "div",
                          { staticClass: "cart-actions__counter-field" },
                          [
                            _c("div", { staticClass: "cart-counter" }, [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "cart-counter__action cart-counter__action--minus",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.deleteCountFromCart(item)
                                    },
                                  },
                                },
                                [_c("i", { staticClass: "fa fa-minus" })]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "cart-counter__field" },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: item.quantity,
                                        expression: "item.quantity",
                                      },
                                    ],
                                    staticClass: "cart-counter__input",
                                    attrs: { type: "text" },
                                    domProps: { value: item.quantity },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          item,
                                          "quantity",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "cart-counter__action cart-counter__action--plus",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.addCountToCart(item)
                                    },
                                  },
                                },
                                [_c("i", { staticClass: "fa fa-plus" })]
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "cart-actions__delete" }, [
                          _c(
                            "button",
                            {
                              staticClass: "cart-item-delete-btn",
                              on: {
                                click: function ($event) {
                                  return _vm.removeFromCart(item)
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "fa fa-trash cart-item-delete-btn__icon",
                              }),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
              ]
            )
          }),
          0
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "cart-page__aside" }, [
      _c("div", { staticClass: "summary-cart-info" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "summary-cart-info__part summary-cart-info__part--products",
          },
          [
            _c("div", { staticClass: "summary-cart-info__block-title" }, [
              _vm._v("Корзина"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "summary-cart-info__part-content" }, [
              _c("div", { staticClass: "summary-products" }, [
                _c("div", { staticClass: "summary-products__row" }, [
                  _c("div", { staticClass: "summary-products__label" }, [
                    _vm._v("Товары (" + _vm._s(_vm.$cart.counts) + ")"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "summary-products__price" }, [
                    _vm._v(
                      _vm._s(
                        _vm.formatNumberWithSpaces(_vm.$cart.raw_summary)
                      ) + " руб."
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _vm.$cart.profit_cart
                  ? _c("div", { staticClass: "summary-products__row" }, [
                      _c("div", { staticClass: "summary-products__label" }, [
                        _vm._v("Скидка"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "summary-products__price summary-products__price--sale",
                        },
                        [
                          _vm._v(
                            "-" +
                              _vm._s(
                                _vm.formatNumberWithSpaces(
                                  _vm.$cart.profit_cart
                                )
                              ) +
                              " руб."
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "summary-cart-info__part summary-cart-info__part--summary-payment",
          },
          [
            _c(
              "div",
              { staticClass: "summary-cart-info__row summary-cart-price" },
              [
                _c("div", { staticClass: "summary-cart-price__label" }, [
                  _vm._v("К оплате"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "summary-cart-price__value" }, [
                  _vm._v(
                    _vm._s(_vm.formatNumberWithSpaces(_vm.$cart.summary)) +
                      " руб."
                  ),
                ]),
              ]
            ),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "summary-cart-info__checkout" }, [
      _c("div", { staticClass: "summary-cart-info__actions" }, [
        _c(
          "a",
          {
            staticClass: "btn btn-primary summary-cart-info__checkout-btn",
            attrs: { href: "/cart/checkout/" },
          },
          [_vm._v("Перейти к оформлению")]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "summary-cart-info__checkout-msg" }, [
        _vm._v(
          "Вы можете оформить заказ как физическое или юридическое лицо.\n          Выбрать способ оплаты и настроить удобную доставку."
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }